module.exports = __webpack_public_path__ + "img/top-logo.e825267f.svg";